"use strict";

exports.__esModule = true;
var _LoggerContext = require("./LoggerContext");
Object.keys(_LoggerContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerContext[key]) return;
  exports[key] = _LoggerContext[key];
});
var _LoggerController = require("./LoggerController");
Object.keys(_LoggerController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoggerController[key]) return;
  exports[key] = _LoggerController[key];
});